import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TranscriptReplayPage } from '@apps/web/features/transcript_replay';

export const Route = createFileRoute('/_app/admin/agent/virtualization')({
    head: () => ({
        meta: [{ title: 'Virtualization | Internal Admin Agent' }],
    }),
    validateSearch: z.object({
        run: z.string().uuid().optional().catch(undefined),
    }),
    component: VirtualizationRoute,
});

function VirtualizationRoute() {
    const { run } = Route.useSearch();
    return <TranscriptReplayPage runId={run ?? null} />;
}
